import { Box, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material'
import { FormProps } from '@yard/app/models/form-props.model'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslate } from '@tolgee/react'
import { Controller, useForm } from 'react-hook-form'
import { ImoClassStackingRuleDto } from '@yard/app/api/dg-config-api'
import { DGStackingRuleFormProfile } from './dg-stacking-rules-table-form.profile'
import { mapDtoToFormProfile } from './dg-stacking-rules-table-form.mapper'
import { schema } from './dg-stacking-rules-table-form.scheme'

interface Props extends FormProps {
  onSubmit: (formValues: DGStackingRuleFormProfile) => Promise<void> | void
  dgStackingRuleDto: ImoClassStackingRuleDto
}

const DGStackingRulesTableForm = ({ id, onSubmit, dgStackingRuleDto }: Props) => {
  const { t } = useTranslate()
  const { handleSubmit, control, formState } = useForm<DGStackingRuleFormProfile>({
    resolver: yupResolver(schema),
    defaultValues: mapDtoToFormProfile(dgStackingRuleDto),
  })

  return (
    <Box
      id={id}
      component='form'
      noValidate
      autoComplete='off'
      onSubmit={handleSubmit(onSubmit)}
      my={1}
    >
      <Stack gap={2}>
        <Typography variant='body2' color='text.secondary'>
          {t('dgStackingRulesFormImoClass', 'IMO Class')}: <strong>{dgStackingRuleDto.imoClass}</strong>
        </Typography>
        <Controller
          name='maxTiers'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              required
              type='number'
              label={t('maxTiers', 'Max Tiers')}
              error={!!formState.errors.maxTiers}
              helperText={formState.errors.maxTiers?.message}
              inputProps={{ min: 0 }}
            />
          )}
        />
        <Controller
          name='isStackingOnTopAllowed'
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  checked={field.value}
                  onChange={field.onChange}
                  color='primary'
                />
              }
              label={t('isStackingOnTopAllowed', 'Stacking on top allowed')}
            />
          )}
        />
      </Stack>
    </Box>
  )
}

export default DGStackingRulesTableForm
